
import { HomeWidget } from "@portal/arq-portal-core";
import React from "react";
import {AlertasList} from "./AlertasList";

export const MiEscritorio = (props:any) => {
    
    return <HomeWidget titulo={props.titulo??"Mi escritorio"}>
        <AlertasList data={props.data}></AlertasList>
    </HomeWidget>

}